import * as React from 'react';
import Typography from '@mui/material/Typography';

const ID = "2bea4a24-0cf9-48f3-ba57-b0ddc202efc6"

const ArmsIndicator2 = ({ metrics, setMetrics, metricsData }) => {
  const [data, setData] = React.useState(false)

  React.useEffect(() => {
    if (!metrics.find(metric => metric === ID)) {
      metrics.push(ID)
      setMetrics(metrics)
    }

    if (metricsData) {
      setData(metricsData[ID])
    }
  }, [metricsData, metrics, setMetrics])

  return (
    (data === true) ? <Typography style={{ padding: '5px', color: 'green' }} >Open </Typography> :
      <Typography style={{ padding: '5px', color: 'red' }}>Closed </Typography>
  )
}
export default ArmsIndicator2;